export default __webpack_public_path__ + "static/media/ntorq-125-fi.627aa480.svg";